import { Card, Box, styled } from "@mui/material";

// STYLED COMPONENTS
const CardRoot = styled(Card)(() => ({
  height: "100%",
  padding: "8px 12px",
}));

const CardTitle = styled("div")(({ subtitle, color }) => ({
  fontSize: "1rem",
  fontWeight: "500",
  textTransform: "capitalize",
  marginBottom: subtitle ? "4px" : "8px",  // Reduce margin-bottom when there's a subtitle
  color: color || "#333",  // If no color is passed, default to #333
  // color: color || "rgba(0, 102, 102, 0.96)", 

}));

// COMPONENT
export default function SimpleCard({ children, title, subtitle, titleColor }) {
  return (
    <CardRoot elevation={6}>
      <CardTitle subtitle={subtitle} color={titleColor}>
        {title}
      </CardTitle>
      {subtitle && <Box mb={1}>{subtitle}</Box>}
      {children}
    </CardRoot>
  );
}
